module.exports = __webpack_public_path__ + "img/dbanner.a89346db.png";